/**
 * After a deploy, a tab opened before it asks for code chunks that no longer exist on the server
 * (ChunkLoadError). Reloading fetches the new version. At most one reload per 30 seconds, so a
 * chunk that is really missing can't loop; without session storage there is no reload at all.
 */

const RELOADED_AT = "meetoor.chunkReloadedAt";
const RELOAD_GAP_MS = 30 * 1000;

function isChunkError(error) {
    return !!error && (error.name === "ChunkLoadError" || /Loading (CSS )?chunk [\w-]+ failed/.test(error.message || ""));
}

function reloadOnce() {
    try {
        if (Date.now() - Number(sessionStorage.getItem(RELOADED_AT) || 0) < RELOAD_GAP_MS) return;
        sessionStorage.setItem(RELOADED_AT, String(Date.now()));
    } catch {
        return;
    }
    window.location.reload();
}

export function reloadOnStaleChunks() {
    window.addEventListener("error", (event) => isChunkError(event.error) && reloadOnce());
    window.addEventListener("unhandledrejection", (event) => isChunkError(event.reason) && reloadOnce());
}
